import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/index",
    component: () => import("../view"),
  },
  {
    path: "/login/redirect",
    name: "预2约",
    meta: {
      title: "登录重定向",
      omitLogin: true,
    },
    component: () => import("../view/login/redirect.vue"),
  },
  {
    path: "/phone",
    name: "预2约",
    meta: {
      title: "身份验证",
    },
    component: () => import("../view/login/login.vue"),
  },
  {
    path: "/phones",
    name: "预2约",
    meta: {
      title: "身份验证",
    },
    component: () => import("../view/login/logins.vue"),
  },
  
  
  {
    meta: {
      title: "查看详情",
    },
    path: "/test_info",
    name: "报考信息",
    component: () => import("../view/test_info/test_info.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/test_cxkq3",
    name: "报考详情已驳回",
    component: () => import("../view/test_info/test_cxkq3.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/resultsInvalid",
    name: "成绩作废",
    component: () => import("../view/test_info/resultsInvalid.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/test_cxkq2",
    name: "报考详情待考试",
    component: () => import("../view/test_info/test_cxkq2.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/test_cxkq",
    name: "报考详情",
    component: () => import("../view/test_info/test_cxkq.vue"),
  },
  {
    meta: {
      title: "预约考试",
    },
    path: "/ownmessage",
    name: "个人信息",
    component: () => import("../view/ownmessage/ownmessage.vue"),
  },
  
  {
    meta: {
      title: "预约考试",
    },
    path: "/reserve",
    name: "自主报考-预约时间",
    component: () => import("../view/reserve/reserve.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/order_form",
    name: "自主报考-订单页",
    component: () => import("../view/order_form/order_form.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/order_pay",
    name: "预约",
    component: () => import("../view/order_pay/order_pay.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/dynamicmore",
    name: "动态",
    component: () => import("../view/order_pay/dynamicmore.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/resultmore",
    name: "成绩",
    component: () => import("../view/order_pay/resultmore.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/audit",
    name: "平台审核",
    component: () => import("../view/audit/audit.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/social",
    name: "社保",
    component: () => import("../view/social/social.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/order_mypay",
    name: "线上支付",
    component: () => import("../view/order_mypay/order_mypay.vue"),
  },
  {
    meta: {
      title: "机构支付",
    },
    path: "/order_morepay/:orderId",
    name: "支付",
    component: () => import("../view/order_mypay/order_morepay.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/order_payinfo",
    name: "查看已完成订单",
    component: () => import("../view/order_payinfo/order_payinfo.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/orderpaysuccee",
    name: "支付成功待平台审核",
    component: () => import("../view/orderpaysuccee/orderpaysuccee.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/upload_files",
    name: "自主上传文件",
    component: () => import("../view/upload_files/upload_files.vue"),
  },
  {
    meta: {
      title: "预约考试",
    },
    path: "/upload_filesC",
    name: "自主上传文件2",
    component: () => import("../view/upload_files/upload_filesC.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/order_pinfo",
    name: "机构查看支付信息",
    component: () => import("../view/order_pinfo/order_pinfo"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/order_pinfomy",
    name: "自主订单查看已完成",
    component: () => import("../view/order_pinfo/order_pinfomy"),
  },
  //机构页面相关
  {
    meta: {
      title: "上传名单",
    },
    path: "/uploadList",
    name: "机构上传文件",
    component: () => import("@/view/organization/uploadList/batch.vue"),
  },
  {
    meta: {
      title: "批量约考",
    },
    path: "/batchSignUp",
    name: "批量约考",
    component: () => import("@/view/organization/batchSignUp/index.vue"),
  },
  {
    meta: {
      title: "修改报考详情",
    },
    path: "/batchSignUp/review/:id/:type",
    name: "机构上传文件显示",
    component: () => import("@/view/organization/batchSignUp/review.vue"),
  },
  {
    meta: {
      title: "查看报考详情",
    },
    path: "/batchSignUp/preview/:id/:type",
    name: "查看报考详情",
    component: () => import("@/view/organization/batchSignUp/preview.vue"),
  },
  {
    meta: {
      title: "协会查看详情",
    },
    path: "/batchSignUp/info/:id/:type",
    name: "协会查看详情",
    component: () => import("@/view/organization/batchSignUp/info.vue"),
  },
  {
    meta: {
      title: "选择考场和时间",
    },
    path: "/batchSignUp/appointment/edit",
    name: "机构报考-预约时间",
    component: () => import("@/view/organization/batchSignUp/appointment/edit.vue"),
  },
  {
    meta: {
      title: "我的订单",
    },
    path: "/order/list",
    name: "我的订单",
    component: () => import("@/view/organization/order/list.vue"),
  },
  {
    meta: {
      title: "订单支付",
    },
    path: "/order/pay/:id",
    name: "查看订单",
    component: () => import("@/view/organization/order/pay.vue"),
  },
  {
    meta: {
      title: "支付成功",
    },
    path: "/order/paySuccess",
    name: "订单详情",
    component: () => import("@/view/organization/order/paySuccess.vue"),
  },
  {
    meta: {
      title: "订单详情",
    },
    path: "/order/detail/:id",
    name: "订单详情",
    component: () => import("@/view/organization/order/detail.vue"),
  },
  {
    meta: {
      title: "考生动态",
    },
    path: "/exam/dynamic",
    name: "考生动态",
    component: () => import("@/view/organization/examDynamic/index.vue"),
  },
  {
    meta: {
      title: "成绩证书",
    },
    path: "/grade",
    name: "考生动态",
    component: () => import("@/view/organization/grade/index.vue"),
  },

  {
    meta: {
      title: "身份验证",
    },
    path: "/uploadcobmit",
    name: "机构支付成功页面",
    component: () => import("../view/reserve/uploadcobmit.vue"),
  },
  {
    meta: { 
      title: "身份验证",
    },
    path: "/word",
    name: "消息通知info",
    component: () => import("../view/word/word.vue"),
  },
  {
    meta: {
      title: "身份验证",
    },
    path: "/message",
    name: "公共消息info",
    component: () => import("../view/word/message.vue"),
  },
  {
    meta: {
      title: "协会审核",
    },
    path: "/associationAudit",
    name: "报名审核info",
    component: () => import("../view/confirm/associationAudit.vue"),
  }, 
  {
    meta: {
      title: "考生签名",
    },
    path: "/signature",
    name: "考生签名",
    component: () => import("../view/confirm/signature.vue"),
  }, 
  {
    meta: {
      title: "考试名单",
    },
    path: "/examList",
    name: "考试名单",
    component: () => import("@/view/confirm/examList.vue"),
  },
  {
    meta: {
      title: "用户管理",
    },
    path: "/userManage",
    name: "用户管理",
    component: () => import("@/view/confirm/userManage.vue"),
  },
  {
    meta: {
      title: "查看用户信息",
    },
    path: "/userManage/:id/preview",
    name: "查看用户信息",
    component: () => import("@/view/organization/userManage/userInfo.vue"),
  },
  {
    meta: {
      title: "编辑用户信息",
    },
    path: "/userManage/:id/edit",
    name: "编辑用户信息",
    component: () => import("@/view/organization/userManage/userInfo.vue"),
  },
  {
    meta: {
      title: "考场安排",
    },
    path: "/examRoomPlan",
    name: "考场安排",
    component: () => import("@/view/confirm/examRoomPlan.vue"),
  },

  {
    meta: {
      title: "身份验证",
    },
    path: "/order_payinfojigou",
    name: "报名审核查看订单info",
    component: () => import("../view/confirm/order_payinfojigou.vue"),
  },
  //待考试重新预约
  {
    meta: {
      title: "重新预约",
    },
    path: "/reschedule",
    name: "重新预约",
    component: () => import("../view/test_info/reschedule.vue"),
  },
  //未考试重新预约
  {
    meta: {
      title: "重新预约",
    },
    path: "/rescheduleNotTest",
    name: "重新预约",
    component: () => import("../view/test_info/rescheduleNotTest.vue"),
  },

  {
    meta: {
      title: "身份验证",
    },
    path: "/infomore/:phone",
    name: "报名审核查看info",
    component: () => import("../view/confirm/infomore.vue"),
  },

  {
    meta: {
      title: "身份验证",
    },
    path: "/certificate",
    name: "证书详情页",
    component: () => import("../view/certificate/certificate.vue"),
  },
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "预约考试系统";
  }
  next();
});
export default router;
